export default __webpack_public_path__ + "static/media/Home.36a94e7c.svg";